/**
 * What's New helpers
 *
 * Tracks the last changelog version a user has seen (persisted in localStorage)
 * and decides whether the "What's New" modal should be shown.
 */

import { CURRENT_VERSION } from '@/data/changelog';

const LAST_SEEN_VERSION_KEY = 'highfive_last_seen_version';

export const getLastSeenVersion = (): string | null => {
  return localStorage.getItem(LAST_SEEN_VERSION_KEY);
};

export const setLastSeenVersion = (version: string): void => {
  localStorage.setItem(LAST_SEEN_VERSION_KEY, version);
};

export const shouldShowWhatsNew = (): boolean => {
  const lastSeen = getLastSeenVersion();
  return lastSeen !== CURRENT_VERSION;
};
